<template>
  <div class="form-container editform-container">
    <h1><span>被害と生息</span>
	<span class="color">
		（{{ typeMapping[editableData.type] }}）
	</span>
	</h1>
    <form>
      <table class="wildlife-list-edit-table">
        <tbody>
          <tr>
            <td class="title">受付番号</td>
            <td>：<input type="text" id="no" disabled
				:value="editableData.no" /></td>
          </tr>
          <tr>
            <td class="title">利用者</td>
            <td>：<input type="text" id="no" disabled
				:value="editableData.id + ' ' + editableData.nameKanji" />
			</td>
          </tr>
          <tr>
            <td class="title">確認場所</td>
            <td>：<input type="text" id="municipalities"
                v-model="editableData.municipalities"
                placeholder="都道府県市区町村" />
            </td>
          </tr>
          <tr>
            <td class="title"></td>
            <td>　<input type="text" id="strAdd"
                v-model="editableData.strAdd"
                placeholder="地区" />
            </td>
          </tr>
          <tr>
            <td class="title">日時</td>
            <td>：<input type="datetime-local" id="damageDate"
				v-model="editableData.damageDate" />
            <span v-if="errors.damageDate" class="error-message">
				{{ errors.damageDate }}</span>
            </td>
          </tr>
          <tr>
            <td class="title">獣種</td>
            <td>：
               <select id="animalType" v-model="editableData.animalType">
               <option disabled value="">選択してください</option>
               <option v-for="type in animalTypes"
				:key="type.value" :value="type.value">
				{{ type.label }}</option>
               </select>
            </td>
		  </tr>
		  <tr>
            <td class="title">頭数</td>
            <td>：
               <select id="count" v-model="editableData.count">
               <option disabled value="">選択してください</option>
               <option v-for="type in headCountTypes"
				:key="type.value" :value="type.value">
				{{ type.label }}</option>
               </select>
            </td>
          </tr>
		  <tr>
            <td class="title">性別</td>
            <td>：
            	<select id="sex" v-model="editableData.sex">
            	<option disabled value="">選択してください</option>
            	<option v-for="type in genderTypes"
				:key="type.value" :value="type.value">
				{{ type.label }}</option>
            	</select>
            </td>
          </tr>
          <tr>
            <td class="title">幼成獣</td>
            <td>：
               <select id="byAnimal" v-model="editableData.byAnimal">
               <option disabled value="">選択してください</option>
               <option v-for="type in juvenileTypes"
				:key="type.value" :value="type.value">
				{{ type.label }}</option>
               </select>
            </td>
		  </tr>
        </tbody>

        <tbody v-if="isDamageType">
          <tr>
            <td class="title">被害面積(㎡)</td>
            <td>：<input type="text" id="damageArea"
				v-model="editableData.damageArea" />
            <span v-if="errors.damageArea" class="error-message">
			{{ errors.damageArea }}</span>
            </td>
		  </tr>
          <tr v-if="isDamageType">
            <td class="title">被害金額(円)</td>
            <td>：<input type="text" id="damageAmount"
				v-model="editableData.damageAmount" />
            <span v-if="errors.damageAmount" class="error-message">
			{{ errors.damageAmount }}</span>
            </td>
          </tr>
        </tbody>

        <tbody v-if="false">
          <tr>
            <td class="title">体長(㎝)</td>
            <td>：<input id="length" type="text"
				v-model="editableData.length" />
            <span v-if="errors.length" class="error-message">
			{{ errors.length }}</span>
            </td>
		  </tr>
          <tr>
            <td class="title">体重(kg)</td>
            <td>：<input id="totalWeight" itype="text"
				v-model="editableData.totalWeight" />
            <span v-if="errors.totalWeight" class="error-message">
			{{ errors.totalWeight }}</span>
            </td>
          </tr>
        </tbody>

        <tbody>
          <!-- 画像フィールド -->
          <tr>
            <td class="title">画像</td>
              <td>：
                <img :src="editableData.imageUrl" class="thumb"
				@click="imageUp(editableData.imageUrl)" />
				　
                <img :src="editableData.imageUrl1" class="thumb"
				@click="imageUp(editableData.imageUrl1)" />
				　
                <img :src="editableData.imageUrl2" class="thumb"
				@click="imageUp(editableData.imageUrl2)" />
              </td>
          </tr>
          <tr>
            <td class="title">備考</td>
            <td>：
			<textarea id="addNote" v-model="editableData.addNote">
			</textarea>
            <span v-if="errors.addNote" class="error-message">
			{{ errors.addNote }}</span>
            </td>
          </tr>
          <tr>
            <td class="title">緯度</td>
            <td>：
              <input type="text" id="location-latitude" placeholder="緯度"
                v-model="editableData.locationLat" />
			</td>
		  </tr>
		  <tr>
            <td class="title">経度</td>
			<td>　
              <input type="text" id="location-longitude" placeholder="経度"
                v-model="editableData.locationLon" />
		  </td>
          </tr>
        </tbody>
      </table>
    </form>
    <div class="edit-button-group">
      <button type="button" @click="cancelEdit" class="second">キャンセル</button>
      <button type="submit" @click="validateAndSaveChanges" class="alert">更新</button>
    </div>
  </div>
	<!-- ポップアップ -->
	<div class="popup" v-if="popup_on">
    	<img :src="popup_src" @click="imageDown" class="big" />
    </div>
</template>

<script>
//import "@/assets/styles/Wildlife-edit-table.css";
import axios from "axios";
axios.defaults.timeout = process.env.VUE_TIMEOUT||5000;

export default {
  data() {
    return {
      editableData: {},
      isDamageType: false,
      isSightType: false,
	  popup_on: false,
	  popup_src: '',
      errors: {}, // エラーオブジェクトを追加
      typeMapping: {
        "1": "被害",
        "2": "捕獲",
        "3": "目撃",
        "4": "痕跡",
        "5": "わな",
        "6": "柵",
        "9": "その他"
      },
      animalTypes: [
        { value: "01", label: "イノシシ"},
        { value: "02", label: "ニホンジカ"}, 
        { value: "03", label: "クマ"}, 
        { value: "04", label: "サル"}, 
        { value: "05", label: "タヌキ"}, 
        { value: "06", label: "アナグマ"}, 
        { value: "07", label: "ハクビシン"}, 
        { value: "08", label: "アライグマ"}, 
        { value: "09", label: "ヌートリア"}, 
        { value: "10", label: "鳥類"}, 
        { value: "11", label: "その他"}
      ],
      headCountTypes: [
        { value: "1", label: "1" },
        { value: "2", label: "2" },
        { value: "3", label: "3" },
        { value: "4", label: "4" },
        { value: "5", label: "5以上" },
        { value: "6", label: "不明" },
      ],
      genderTypes: [
        { value: "1", label: "オス"}, 
        { value: "2", label: "メス"}, 
        { value: "3", label: "オスとメス"}, 
        { value: "6", label: "不明"}
      ],
      juvenileTypes: [
        { value: "1", label: "成獣"}, 
        { value: "2", label: "幼獣"}, 
        { value: "3", label: "幼獣と成獣"}, 
        { value: "4", label: "不明"}
      ],
    };
  },
  created() {
	try {
      if (this.$route.query.data) {
		var tmp = decodeURIComponent(this.$route.query.data);
        this.editableData = JSON.parse(tmp);
    	this.isDamageType = (this.editableData.type == "1");
    	this.isSightType = (this.editableData.type == "2");
	  }
	} catch(e) {
		alert(e);
	}
  },
  mounted() {
	try {
    if (this.editableData.damageDate) {
      const date = new Date(this.editableData.damageDate);
      date.setTime(date.getTime() + 9 * 60 * 60 * 1000); // 日本時間に調整（9時間をミリ秒で加算）

      // datetime-local用にフォーマット (YYYY-MM-DDTHH:MM)
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      this.editableData.damageDate = `${year}-${month}-${day}T${hours}:${minutes}`;
    }
	} catch (e) {
		alert(e);
	}
  },
  methods: {
	imageDown() {
		this.popup_on = false;
	},
	imageUp(src) {
		if (this.popup_src != src) {
			this.popup_src = src;
			this.popup_on = true;
		} else {
			this.popup_on = !this.popup_on;
		}
	},
    validateForm() {
      const errors = {};

      // 必須項目のエラーチェック
      if (!this.editableData.damageDate) errors.damageDate = "日時は必須です";
      
      // 桁数とバリデーションチェック
      // 被害面積(㎡)
      if (this.editableData.damageArea && !/^(\d{1,9}(\.\d{1,2})?)$/.test(this.editableData.damageArea)) {
        errors.damageArea = "被害面積(㎡)は整数部9桁、小数部2桁までで入力してください";
      }
      // 被害金額(円)
      if (this.editableData.damageAmount && (this.editableData.damageAmount < 0 || this.editableData.damageAmount.toString().length > 12)) {
        errors.damageAmount = "被害金額(円)は0以上、12桁までで入力してください";
      }
      // 体長(㎝)
      if (this.editableData.length && !/^(\d{1,3}(\.\d{1,2})?)$/.test(this.editableData.length)) {
        errors.length = "体長(㎝)は整数部3桁、小数部2桁までで入力してください";
      }
      // 体重(kg)
      if (this.editableData.totalWeight && !/^(\d{1,14}(\.\d{1,2})?)$/.test(this.editableData.totalWeight)) {
        errors.totalWeight = "体重(kg)は整数部14桁、小数部2桁までで入力してください";
      }
      // 備考
      if (this.editableData.addNote && this.editableData.addNote.length > 1000) {
        errors.addNote = "備考は1000桁以内で入力してください";
      }

      this.errors = errors;
      return Object.keys(errors).length === 0;
    },
    async validateAndSaveChanges() {
      if (this.validateForm()) {
        this.saveChanges().then(() => {
          //this.$router.push({ name: "DamageList" });
		});
      } else {
        // バリデーションエラーがある場合にポップアップで警告を表示
        alert('入力エラーがあります');
      }
    },
    async saveChanges() {
      let storedAdmins = JSON.parse(localStorage.getItem('adminAgencies')) || [];
      storedAdmins.push(this.newAdmin);
      localStorage.setItem('adminAgencies', JSON.stringify(storedAdmins));

      // JWTトークンを取得
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId");
      // datetime-localの値を取得
      const inputDateTime = this.editableData.damageDate;
      // Dateオブジェクトとして作成（ローカルタイムとして解釈される）
      const localDate = new Date(inputDateTime);
      // ISO形式に変換してフロントエンドから送信
      const adjustedDateTime = localDate.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:MM"形式に調整

      try {
        // サーバーに送信するデータをJSONに加工
        const dataToSubmit = {
          region_Id: this.editableData.region_Id || null,
          no: this.editableData.no || null,
          id: this.editableData.id || null,
          type: this.editableData.type || null,
          damageArea: this.editableData.damageArea || null,
          damageAmount: this.editableData.damageAmount || null,
          length: this.editableData.length || null,
          totalWeight: this.editableData.totalWeight || null,
          animalType: this.editableData.animalType || null,
          byAnimal: this.editableData.byAnimal || null,
          municipalities: this.editableData.municipalities || null,
          strAdd: this.editableData.strAdd || null,
          damageDate: adjustedDateTime || null,
          count: this.editableData.count || null,
          sex: this.editableData.sex || null,
          addNote: this.editableData.addNote || null,
          locationLat: this.editableData.locationLat || null,
          locationLon: this.editableData.locationLon || null,
          modifierId: userId || null,
          modifyDate: null,
        };
        for (const [key, value] of Object.entries(dataToSubmit)) {
          if (value === undefined) {
            dataToSubmit[key] = "";  // undefinedの場合は空文字に設定
          }
        }

        // APIリクエスト送信
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/wildlifeDamage/update`,
          dataToSubmit,
          {
            headers: {
              Authorization: `Bearer ${token}`, // JWTトークンを送信
            },
          }
        );

        // ステータスコード200の場合（送信成功）
        if (response.status === 200) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          alert("データが正常に登録されました");
        } else {
			alert("不明なエラーです");
		}
        this.$router.push({ name: "DamageList" });
      } catch (error) {
alert(error.response.data.message);
        alert("タイムアウトです、ログインしなおしてください");
        this.$router.push({ name: 'Login' });
      }
    },
    cancelEdit() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.usual { background-color: #17a2b8; }
.first { background-color: #28a745; }
.alert { background-color: #ff6347; }
.second { background-color: #6c757d; }
.title { font-weight: bold; }
.color { color: green; }
.thumb { max-width: 100px; cursor: zoom-in; }
.big { max-width: 300px; cursor: zoom-out; }
.popup {
  width:600px;
  height:auto;
  display: block;
  position: fixed;
  top: 15%;
  left: 70%;
  transform:translate(-50%);
  text-align: right;
}
</style>
